import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useHistory } from 'react-router'
import CloseIcon from '@material-ui/icons/Close';
import firebase from '../firebase'
import 'firebase/firebase-firestore'
import 'firebase/storage';
import { CircularProgress, Button } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar';
import Backdrop from '@material-ui/core/Backdrop';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useForm } from "react-hook-form";
import Resizer from "react-image-file-resizer";


function Profile(props) {
	const baseURL = process.env.PUBLIC_URL;
	const currentUser = firebase.getCurrentUsername();
	const [userData, setUserData] = useState('');
	const [userPic, setUserpic] = useState();
	const [backdrop, setBackdrop] = useState(false);
	const { register, handleSubmit} = useForm();
	const history = useHistory()

	const resizeFile = (file) =>
	new Promise((resolve) => {
		Resizer.imageFileResizer(
		file,
		200,
		200,
		"jpg",
		80,
		0,
		(uri) => {
			resolve(uri);
		},
		"file"
		);
	});

	const close = ()=>{
		props.history.replace(baseURL+'/dashboard')
	}


	useEffect (()=> {
		if(!currentUser) {
			return props.history.replace(baseURL+'/login')
		} else{
			if(localStorage.getItem('data') !== null){
				setUserData(JSON.parse(localStorage.getItem('data')));
				setUserpic(localStorage.getItem('pic'));
				console.log('desde sesión')
			} else {
				const data = firebase.db.collection("students").where("uuid", "==", currentUser[0].uid).get().then((querySnapshot) => {
					if(!querySnapshot.empty) {
						setUserData(querySnapshot.docs[0].data());
						setUserpic(querySnapshot.docs[0].data().pic);
					  } else {
						setUserpic({error:'error'});
					  }
				}); 
			}
		}
	},[]);

	/* save data ----------------------------------------------------------------- */ 

	const saveProfile = (data)=>{
       console.log(data);
	   setBackdrop(true);
	   const obj = {};
	   for(const [key, value] of Object.entries(data)){
		   if(value != undefined){
			obj[key] = value;
		   }
	  }
	  if (Object.entries(obj).length != 0){
		  console.log(obj);
		firebase.db.collection("students").where("uuid", "==", currentUser[0].uid)
		.get()
		.then(function(querySnapshot) {
			querySnapshot.forEach(function(doc) {
				firebase.db.collection("students").doc(doc.id).update(obj).then((e)=>{ 
					console.log('datos actualizados')
					localStorage.clear();
					props.history.replace(baseURL+'/dashboard')
				}).catch((e) =>{
					console.log(e);
				});
			});
	   })
	  } else {
		  console.log('no se cambio nada');
		  setBackdrop(false);
	  }
	}

	/* Upload Photo ----------------------------------------------------------------- */ 

	async function uploadImage(file){
		let that = this;
		let storageRef = firebase.storage.ref('//pictures_profile/' + file.name)
		let uploadTask = storageRef.put(file);
		setBackdrop(true);
		await uploadTask.on('state_changed', function(snapshot){
		}, function(error){
			console.log(error)
		}, function(){
			let ref = firebase.storage.refFromURL('gs://aforo-bjj.appspot.com/pictures_profile/'+file.name)
			ref.getDownloadURL().then(function(url) {
				setUserpic(url);
				localStorage.setItem('pic', url);
				firebase.db.collection("students").where("uuid", "==", currentUser[0].uid)
				.get()
				.then(function(querySnapshot) {
					querySnapshot.forEach(function(doc) {
						firebase.db.collection("students").doc(doc.id).update({
							pic: url
						}).then(()=>{ 
							console.log('imagen guardada')
							setBackdrop(false);
						});
					});
			   })
			})
		});
	}

	async function changePhoto(e){
		if(e.target.files[0]){
			let file = await resizeFile(e.target.files[0]);
			console.log(file)

			let blob = file.slice(0, file.size, file.type); 
			let name = currentUser[0].uid + '.' +file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
			let newFile = new File([blob], name, {type: file.type});

			uploadImage = uploadImage(newFile);
		}
	}

	/* render ----------------------------------------------------------------- */

	if (userData != ''){
		if(localStorage.getItem('data') == null){
			localStorage.setItem('data', JSON.stringify(userData));
			localStorage.setItem('pic', userData.pic);
		}
		const items = []
		for (let i=0 ; i < userData.strips ;i++) {
		  items.push(<div className="strip"></div>)
		}

		return (
			<main>
			<Backdrop className="backdrop"  open={backdrop}>
				<CircularProgress color="inherit" />
			</Backdrop>
				<header className="header-aux">
					<div></div>
					<h3>Datos Personales</h3>
					<CloseIcon onClick={close} />
				</header>
				<section className="container-aux">
					<div class="topBackground">
						<div className="MainInfoContainer">
							<div className="avatarContainer">
								<label htmlFor="upload-photo">
									<EditOutlinedIcon className="changePic" />
									{userPic ? 
										<Avatar className="avatar" src={userPic} />
										:
										<Avatar className="avatar">{userData.name.substr(0, 1)}{userData.lastname.substr(0, 1)}</Avatar>
									}
								</label>
								<input id="upload-photo" type="file" accept=".jpg, .png, .jpeg" className="inputPic" onChange={changePhoto} />
							</div>
							<h3 className="name">{userData.name} {userData.lastname}</h3>
							{ userData.nick ? 
							<h4 className="name">({userData.nick})</h4>
							: null
							}
							<h5 className="email">{userData.email}</h5>
							
							<div className={`${userData.belt} belt`}>
								<div className={`${userData.belt} blackSide`} >
									{items}
								</div>
							</div> 
						</div>
					</div>

					<div className="contentProfile">
						<form  autoComplete="off" noValidate onSubmit={handleSubmit(saveProfile)}>
							<TextField {...register("name")} className="profileInput" defaultValue={userData.name}  label="Nombre" maxLength="12" variant="outlined" />
							<TextField {...register("lastname")} className="profileInput"  defaultValue={userData.lastname} label="Apellidos" maxLength="12" variant="outlined" />
							<TextField {...register("email")} className="profileInput" defaultValue={userData.email} label="Correo Electrónico" variant="outlined" />
							<TextField {...register("nick")} className="profileInput"  defaultValue={userData.nick} label="Alias" maxLength="20" variant="outlined" />
							<FormControl className="profileSelect first"  variant="outlined">
								<InputLabel id="beltLabel">Cinturon</InputLabel>
								<Select {...register("belt")} className="profileInput" labelId="beltLabel"  defaultValue={userData.belt} label="Cinturon">
									<MenuItem value="white">Blanco</MenuItem>
									<MenuItem value="blue">Azul</MenuItem>
									<MenuItem value="purple">Morado</MenuItem>
									<MenuItem value="brown">Marrón</MenuItem>
									<MenuItem value="black">Negro</MenuItem>
								</Select>
							</FormControl>
							<FormControl className="profileSelect" variant="outlined">
								<InputLabel id="stripLabel">Grados</InputLabel>
								<Select {...register("strips")} className="profileInput"  labelId="stripLabel"  defaultValue={userData.strips} label="Grados">
									<MenuItem value="0">0</MenuItem>
									<MenuItem value="1">1</MenuItem>
									<MenuItem value="2">2</MenuItem>
									<MenuItem value="3">3</MenuItem>
									<MenuItem value="4">4</MenuItem>
								</Select>
							</FormControl>
							<TextField {...register("phone")} className="profileInput" name="phone" defaultValue={userData.phone} label="Teléfono" type="tel" variant="outlined" />
							<TextField {...register("address")} className="profileInput" name="address" multiline rows={4} defaultValue={userData.address} label="Dirección"  variant="outlined" />
							<TextField {...register("weight")} className="profileInput" name="weight" step="0.1" min='0' max='3' type="number" defaultValue={userData.weight} label="Peso"  InputProps={{endAdornment: <InputAdornment position="end">Kg</InputAdornment>}}  variant="outlined" />
							<TextField {...register("height")} className="profileInput" name="height" step="0.1" min='0' max='3' type="number" defaultValue={userData.height} label="Estatura"  InputProps={{endAdornment: <InputAdornment position="end">Mt</InputAdornment>}}  variant="outlined" />
							<button type="submit" className="loginBtnPrincipal">Guardar</button>
						</form>
					</div>
				</section>
			</main>
		)
	} else {
		return (
		<div className="loading">
			<CircularProgress />
		</div>
		)
	}

}

export default withRouter(Profile)